/* eslint-disable no-unused-vars */
import React, { useEffect } from "react";
import utils from "utils";
import { saveModel  } from '../../utils/Functions';

const { rest } = utils;


export default function   () {
  useEffect(() => {
    (async () => {
      const searchParams = new URLSearchParams(window.location.search);
      const ProcessID = searchParams.get("ProcessID");
      localStorage.setItem("Disabled", "True");
     // const result = await rest.get(
  //      `/api/Manager/SetProccessId?proccessId=${ProcessID}`
   //   );
   //   window.location.href = "/JoinPersonalDetails";

      await rest.get(
        `/api/Manager/SetProccessId?proccessId=${ProcessID}`
      ).then(res => {

       
          rest.get(`/api/Manager/GetManagerProcess`)
          .then(res2 => {
            if (res2.data !=null) {
              window.localStorage.setItem("model",res2.data)
              window.localStorage.setItem('deepLink',"true");

              saveModel(res2.data,21);
              window.location.href="/JoinPersonalDetails";
            }
          });
         })
    })();
  }, []);
  return <div></div>;
}
